module.exports = __webpack_public_path__ + "static/media/masjid_kichula13.3e8820e9.webp";